/**
 * Un toque de campaña social que ya venció, en la campanita.
 *
 * Hasta ahora las campañas no existían para la campanita: los toques vencidos
 * solo se veían entrando a /campaigns → «Toca hoy». Como estas campañas se
 * entregan A MANO —el sistema no manda nada—, un toque que nadie mira es un
 * toque que no sale: es justamente el caso que la campanita tiene que avisar.
 */
import { Link } from 'react-router-dom';

import { ChannelIcon } from '@/components/ui/channel-icon';
import type { SocialTouchesDueRow } from '@/types/database.types';

import { PanelSectionHeader } from './PanelSectionHeader';
import { TiempoRelativo } from './TiempoRelativo';

export function DueTouchItem({
  touch,
  onNavigate,
}: {
  touch: SocialTouchesDueRow;
  onNavigate: () => void;
}) {
  return (
    <li className="hover:bg-surface-hi/40 border-border-dim/40 border-b last:border-0">
      <Link
        to={`/campaigns?campana=${touch.campaign_id}`}
        onClick={onNavigate}
        className="flex items-center gap-2 px-3.5 py-2 text-caption"
      >
        <ChannelIcon
          channel={touch.channel ?? 'whatsapp'}
          className="text-fg-muted shrink-0"
        />
        <span className="min-w-0 flex-1">
          <span className="text-foreground block truncate">
            Toque {touch.step_order} · {touch.prospect_name ?? 'sin prospecto'}
          </span>
          <span className="text-fg-muted block truncate">
            {touch.campaign_name ?? 'campaña'}
          </span>
        </span>
        <TiempoRelativo iso={touch.scheduled_for} />
      </Link>
    </li>
  );
}

/**
 * Bloque «Campañas» de la campanita: los toques que ya tocaban. Van antes de las tareas
 * porque el toque no se manda solo: si nadie lo copia y lo pega hoy, la secuencia se corta.
 */
export function DueTouchesSection({
  touches,
  onNavigate,
}: {
  touches: readonly SocialTouchesDueRow[];
  onNavigate: () => void;
}) {
  if (touches.length === 0) return null;
  return (
    <div>
      <PanelSectionHeader title="Campañas" aside={<span className="text-primary">{touches.length} para mandar</span>} />
      <ul>
        {touches.slice(0, 6).map((t) => (
          <DueTouchItem key={t.message_id ?? `${t.campaign_id}-${t.step_order}`} touch={t} onNavigate={onNavigate} />
        ))}
      </ul>
    </div>
  );
}
